export default __webpack_public_path__ + "static/0106-e6241816cd62aa35c93ab7884c76434d.png";